<template>
    <div >

        <template v-for="(category, index) in measureResultsByCategory" :key="index">
            <div
                v-if="category.categoryId !== 9"
                :class="index === 0 ? 'pdf-avoid-page-break' : null"
            >

                <div class="pdf-section-title" v-if="index === 0" >Test Details</div>

                <template v-for="(measure, measureIndex) in category.sortedResults" :key="measure.otherMeasureId">
                    <div
                        v-if="!measuresCategoriesById[category.categoryId]?.hideDetails"
                        :style="{marginTop: measureIndex > 0 ? '10px' : null}"
                        :class="index !== 0 ? 'pdf-avoid-page-break' : null"
                    >
                        <SectionWrapper
                            :title="category.fullLabel ? category.fullLabel : category.label"
                            v-if="measureIndex === 0"
                            title-only
                            no-padding
                            header-border
                            :style="{marginTop: index > 0 ? '10px' : null}"
                            class="pdf-avoid-page-break"
                        >
                            <TestDetail :profileTest="profileTest" :measureId="parseInt(measure.otherMeasureId)" :measure="measure" :categoryId="category.categoryId" />
                        </SectionWrapper>
                        <div v-else class="pdf-avoid-page-break">
                            <TestDetail :profileTest="profileTest" :measureId="parseInt(measure.otherMeasureId)" :measure="measure" :categoryId="category.categoryId" />
                        </div>
                    </div>
                </template>

            </div>
        </template>

    </div>
</template>

<script>

import SectionWrapper from "@/components/pdf-export/SectionWrapper";
import {measuresCategoriesById} from "@/js/shared/constants";
import TestDetail from "@/components/pdf-export/components/TestDetail";

export default {
    name: "TestDetailsSection",
    components: {TestDetail, SectionWrapper},
    props: {
        profile: {
            // required: true
        },
        profileTest: {
            required: true
        },
        measureResultsByCategory: {
            required: true
        }
    },
    data() {
        return {
            measuresCategoriesById
        }
    },
    mounted() {

    },
    computed: {

    },
    methods: {

    }
}
</script>

<style scoped>

</style>